module.exports = __webpack_public_path__ + "img/Luxembourg.676ddf98.gif";